import React from 'react'
import ReactDOM from 'react-dom'
import { OffsetOptions } from '@floating-ui/react'
import { Placement } from '@floating-ui/react-dom'

import { Tip, useTip } from '@makyoapp/makyo-ui'

export function Help({
  children,
  noPortal,
  options,
}: {
  children: React.ReactNode
  noPortal?: boolean
  options?: {
    offset?: OffsetOptions
    placement: Placement
  }
}) {
  const {
    x,
    y,
    strategy,
    refs,
    context,
    placement,
    isOpen: isTipOpen,
    arrowRef,
    getReferenceProps,
    getFloatingProps,
  } = useTip(options)

  const tip = (
    <Tip
      className='max-w-[300px] text-m-m z-400!'
      x={x}
      y={y}
      placement={placement}
      strategy={strategy}
      ref={refs.setFloating}
      {...getFloatingProps()}
      context={context}
      arrowRef={arrowRef}
    >
      {children}
    </Tip>
  )
  return (
    <div>
      <span
        ref={refs.setReference}
        className='cursor-pointer rounded-full flex-cc w-6 h-6 border bdr hover:bg-zinc-200 dark:hover:bg-slate-600'
        {...getReferenceProps()}
      >
        ?
      </span>
      {isTipOpen && !noPortal && ReactDOM.createPortal(tip, document.body)}
      {isTipOpen && noPortal && tip}
    </div>
  )
}
